import React from 'react';

import { create as createSelector } from '@spazious/dollhouse-selector';
import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { useLayers } from '../../hooks';

export type FGroupProps = {
  selector: string;
  children: React.ReactElement<{ selector: string }>[];
};

export const FGroup: React.FC<FGroupProps> = ({ selector, children }) => {
  const layers = useLayers();
  return (
    <fgroup selector={selector} visible={layers.isEnabled(FShallowNodeTypesEnum.FGroup)}>
      {children.map((node, idx) => {
        const childSelector = createSelector(idx, selector);
        const { type: Component, props } = node;

        return <Component key={childSelector} {...props} selector={childSelector} />;
      })}
    </fgroup>
  );
};
